import { useDispatch, useSelector } from 'react-redux';
import PageWrapper from '../../../components/page-wrapper'
import { profileReq } from '../../../store/slices/profileSlice';
import { useCallback, useEffect } from 'react';
import { Box, FormControlLabel, Grid, Switch, Typography } from '@mui/material';
import ProfileCard from '../../../components/profile-card';
import { useNavigate } from 'react-router-dom';
import Api from '../../../store/api';
import { showToast } from '../../../utils/toast';

export default function RecentViews() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const RS = useSelector((state: any) => state.profiles)
  const profileState = useSelector((state: any) => state.profiles);
  const hasProfileImageOnly = !!profileState.hasProfileImage;

  useEffect(() => {
    dispatch(profileReq({
      limit: 12,
      page: 1,
      isInit: true,
      listName: "recent",
      hasProfileImage: hasProfileImageOnly,
    }));
  }, [])

  const paginate = (limit: number, page: number) => {
    dispatch(profileReq({
      limit,
      page,
      listName: RS.listName,
      hasProfileImage: hasProfileImageOnly,
    }));
  };

  // eslint-disable-next-line
  const handleScroll = useCallback(
    Api.debounce(() => {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 100 && !RS.isLoading) {
        const totalPages = Math.ceil(RS.totalItems / 12);
        if (RS.currentPage < totalPages) paginate(12, RS.currentPage + 1);
      }
    }, 200),
    [RS.isLoading, RS.currentPage, paginate]
  );

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const onProfileClick = async (user: any) => {
    const result: any = await Api.compressImage(user.img, 300, 300)
    if (!result?.error) {
      const newUser = { ...user, img: result.imageUri }
      sessionStorage.setItem('selectedProfile', JSON.stringify(newUser));
      navigate('/user/view-profile')
    } else { showToast("try again later", "error") }
  };

  const handleHasProfileImageToggle = () => {
    dispatch(profileReq({
      limit: 12,
      page: 1,
      isInit: true,
      listName: "recent",
      hasProfileImage: !hasProfileImageOnly,
    }));
  };

  return (
    <PageWrapper>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 2,
          mb: 2,
          flexWrap: "nowrap",
          overflowX: "auto",
        }}
      >
        <FormControlLabel
          sx={{ m: 0, gap: 1, flexShrink: 0, alignItems: "center" }}
          control={
            <Switch
              checked={hasProfileImageOnly}
              onChange={handleHasProfileImageToggle}
            />
          }
          label={
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                hasDP
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {hasProfileImageOnly ? "Showing image profiles only" : "Showing all profiles"}
              </Typography>
            </Box>
          }
        />
      </Box>
      <Grid container spacing={3}>
        {RS.list.map((user: any, index: number) => {
          return (
            <Grid key={`key-${index + 1}`} item xs={12} sm={6} md={4} lg={3}>
              <ProfileCard onProfileClick={onProfileClick} user={user} />
            </Grid>
          );
        })}
      </Grid>
    </PageWrapper>
  )
}
